import { dayHeading } from "./feed-calendar";
import type { ExperienceRequestRow } from "../types";
function dayKey({
  iso,
  timeZone,
}: {
  readonly iso: string;
  readonly timeZone: string;
}): string {
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone,
    year: "numeric",
    month: "numeric",
    day: "numeric",
  }).formatToParts(new Date(iso));
  const get = (t: string) => parts.find((p) => p.type === t)?.value ?? "";
  return `${get("year")}-${get("month")}-${get("day")}`;
}
type RequestDayGroup = {
  readonly heading: string;
  readonly rows: ExperienceRequestRow[];
};
/** Buckets `rows` by calendar day in `timeZone`, newest day first. Sorts defensively, same as `groupByDay`. */
export function groupRequestsByDay({
  rows,
  now,
  timeZone,
}: {
  readonly rows: readonly ExperienceRequestRow[];
  readonly now: string;
  readonly timeZone: string;
}): RequestDayGroup[] {
  const sorted = rows.toSorted(
    (a, b) => Date.parse(b.createdAt) - Date.parse(a.createdAt),
  );
  const groups: Array<{
    readonly key: string;
    readonly heading: string;
    readonly rows: ExperienceRequestRow[];
  }> = [];

  for (const row of sorted) {
    const key = dayKey({
      iso: row.createdAt,
      timeZone,
    });
    const last = groups[groups.length - 1];

    if (last && last.key === key) {
      last.rows.push(row);
    } else {
      groups.push({
        key,
        heading: dayHeading({
          iso: row.createdAt,
          now,
          timeZone,
        }),
        rows: [row],
      });
    }
  }

  return groups.map(({ heading, rows: groupRows }) => ({
    heading,
    rows: groupRows,
  }));
}
